export const MAX_HOSTED_VIDEO_BYTES = 512 * 1024 * 1024

export type HostedVideoFailure =
  | 'conversion'
  | 'failed'
  | 'missing'
  | 'prepare'
  | 'save'
  | 'status'
  | 'transfer'

export type HostedVideoErrorKey = HostedVideoFailure | 'permission' | 'tooLarge'

const getHttpStatus = (error: unknown): unknown => {
  if (typeof error !== 'object' || error === null) return undefined

  const status = 'status' in error ? error.status : undefined
  if (status != null) return status

  if (!('response' in error)) return undefined
  const { response } = error
  if (
    typeof response !== 'object' ||
    response === null ||
    !('status' in response)
  ) {
    return undefined
  }
  return response.status
}

export const getHostedVideoErrorKey = (
  error: unknown,
  fallback: HostedVideoFailure
): HostedVideoErrorKey => {
  const status = getHttpStatus(error)

  if (status === 413) return 'tooLarge'
  if (status === 403 && fallback !== 'transfer') return 'permission'
  return fallback
}
